import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the EnquiriesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-enquiries',
  templateUrl: 'enquiries.html',
})
export class EnquiriesPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  getEnquiriesPage(page: string){
      this.navCtrl.push(page);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EnquiriesPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/enquiries/enquiries.ts